module.exports = __webpack_public_path__ + "img/spins_8.f05512c4.png";